import axios from "axios";

export interface getEvaluationParams {
    id: string;
    isDeputy?: string | null;
}
export interface LabelAndValue {
    label: string;
    value: number | string;
}
export interface evaluateItemProps {
    queTypeId: evaluationType;
    key: string;
    title: string;
    data: LabelAndValue[];
}
export interface evaluateInfos {
    courseName: string;
    teacherName: string;
    courseNo: string;
    courseSeq: string;
    startTime: string;
    endTime: string;
    id: string;
}
export enum evaluationType {
    radio = "1",
    checkbox = "2",
    textarea = "4"
}
interface evaluateProps {
    evaluation: evaluateInfos;
    participation: string;
    courseStudentNumber: number;
    submitNumber: number;
    resultArr: evaluateItemProps[];
    score: string;
    scoreRank: string;
}

//评教状态
export enum evaluationStatus {
    NotEvaluated = "0", //有评教，未经评教
    Evaluated = "1", //有评教，已进行评教
    EvaluationIsNull = "2" //无评教
}

export function getEvaluation(params: getEvaluationParams) {
    return axios
        .get<SuccessData<evaluateProps>>("/teacher/evaluation/getEvaluation", {
            params
        })
        .then(res => res.data.data)
        .then(res => {
            return {
                ...res,
                resultArr: res.resultArr.map((item, index) => {
                    return {
                        ...item,
                        key: index.toString()
                    };
                })
            };
        });
}
//是否有新结束的评教
export function newEvaluationStatus() {
    return axios
        .get(`/teacher/evaluation/newEvaluationStatus`)
        .then(res => res.data.data);
}
